import { render, staticRenderFns } from "./PagePayment.vue?vue&type=template&id=2fc1eff0&scoped=true&"
import script from "./PagePayment.vue?vue&type=script&lang=js&"
export * from "./PagePayment.vue?vue&type=script&lang=js&"
import style0 from "./PagePayment.vue?vue&type=style&index=0&id=2fc1eff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1eff0",
  null
  
)

export default component.exports